
import { common } from './common/ar';
import { products } from './products/ar';
import { pricing } from './pricing/ar';
import { solutions } from './solutions/ar';

export const ar = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
